import httpRequest from "@/infra/httpRequest";
import ProductDto from "@/application/dto/ProductDto";
import RepositoryInterface from "@/application/repositories/RepositoryInterface";

export default class ProductRepository implements RepositoryInterface<ProductDto>{
  public async getAll(): Promise<ProductDto[]> {
    try {
      const { data } = await httpRequest.get('/products.json');

      return data.products.map((product: any) => {
        const productDto = new ProductDto();

        productDto.fromJson(product);

        return productDto;
      });
    } catch (err) {
      return [];
    }
  }

  public async getByCompaniesPagesId(companiesPagesId: string): Promise<ProductDto[]> {
    try {
      const { data } = await httpRequest.get(`/companies_pages/${companiesPagesId}/products`);

      return data.products.map((product: any) => {
        const productDto = new ProductDto();

        productDto.fromJson(product);

        return productDto;
      });
    } catch (err) {
      return [];
    }
  }
}